// extracted by mini-css-extract-plugin
module.exports = {"headContainer":"Support_headContainer__1eEBa","supportImg":"Support_supportImg__1JAtA","supportImgParentDiv":"Support_supportImgParentDiv__2L15Q"};